import { render, staticRenderFns } from "./pictureNews.vue?vue&type=template&id=0bc219d4&scoped=true&"
import script from "./pictureNews.vue?vue&type=script&lang=js&"
export * from "./pictureNews.vue?vue&type=script&lang=js&"
import style0 from "./pictureNews.vue?vue&type=style&index=0&id=0bc219d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc219d4",
  null
  
)

export default component.exports